import { FC, forwardRef } from 'react';

import {
  CheckedRadioIconStyled,
  RadioContainerStyled,
  RadioIconStyled,
  RadioLabelStyled,
  RadioStyled,
  StyledRadioText,
} from './Radio.styles';
import { RadioProps } from './Radio.types';
import useRadioButton from '@/common/components/hooks/useRadioButton/useRadioButton';

const Radio: FC<RadioProps> = forwardRef<HTMLInputElement, RadioProps>(
  ({ id, name, value, children, isDisabled, checked, onChange: onChangeProp }, ref) => {

    const { disabled, handleChange, isRadioChecked, isValueChecked, buttonName } = useRadioButton({ name, value, disabled: isDisabled, checked, onChange: onChangeProp});

    return (
      <RadioLabelStyled htmlFor={id} disabled={disabled}>
        <RadioContainerStyled disabled={disabled}>
          <RadioStyled
            ref={ref}
            type="radio"
            onChange={handleChange}
            id={id}
            data-testid={id}
            name={buttonName}
            checked={isValueChecked}
            value={value}
            disabled={disabled}
            aria-checked={isValueChecked}
          />
          {isRadioChecked === true ? (
            <CheckedRadioIconStyled disabled={disabled} />
          ) : (
            <RadioIconStyled disabled={disabled} />
          )}
        </RadioContainerStyled>
        <StyledRadioText disabled={disabled} selected={isRadioChecked} as="span" data-testid={`${id}-label`}>
          {children}
        </StyledRadioText>
      </RadioLabelStyled>
    );
  },
);

Radio.displayName = 'Radio';

Radio.defaultProps = {};

export default Radio;
